
import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const Home = lazy(() => import('../pages/home/page'));
const MobileVerification = lazy(() => import('../pages/mobile-verification/page'));
const SelfieUpload = lazy(() => import('../pages/selfie-upload/page'));
const HourlyCharge = lazy(() => import('../pages/hourly-charge/page'));
const PlatformCharge = lazy(() => import('../pages/platform-charge/page'));
const Payment = lazy(() => import('../pages/payment/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  { path: '/', element: <Home /> },
  { path: '/mobile-verification', element: <MobileVerification /> },
  { path: '/selfie-upload', element: <SelfieUpload /> },
  { path: '/hourly-charge', element: <HourlyCharge /> },
  { path: '/platform-charge', element: <PlatformCharge /> },
  { path: '/payment', element: <Payment /> },
  { path: '*', element: <NotFound /> },
];

export default routes;
